import isEmpty from "lodash/isEmpty";
import { useBookingModuleStore, useCalendarRoot, useCalendarRootActions } from "PFApp/booking/store";
import { useEffect } from "react";

export const useResetOrder = () => {
  const calendarRoot = useCalendarRoot();
  const { options, selectedOrder } = useBookingModuleStore((state) => state[calendarRoot].order);
  const { setSelectedOrder, setAvailableOrderOptions } = useCalendarRootActions(calendarRoot);

  useEffect(() => {
    setAvailableOrderOptions(options);
    if (isEmpty(options)) {
      return;
    }
    const availableOrderOptions = new Set(options.map(({ name }) => name.join("-")));
    const isSelectedOrderAvailable = selectedOrder && availableOrderOptions.has(selectedOrder.name.join("-"));
    if (!isSelectedOrderAvailable) {
      setSelectedOrder(null);
    }
  }, [options]);
};
